/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React from 'react';
import { Button, CircularProgress, Grid, Typography, Alert } from '@mui/material';
import { useState } from 'react';
import { Formik, Form, Field } from 'formik'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { makeStyles } from 'tss-react/mui';
import WebSDK from "@loginid/sdk";
import * as Yup from 'yup'
import { TextField } from 'formik-mui'
import { BsClipboard } from "react-icons/bs";
import MainCard from '../../../../../../components/ui-elements/cards/MainCard';
import { Box } from '@mui/system';


const UserLoginId = () => {

    const [loginRslt, setLoginRslt] = useState({})
    const loginsdk = new WebSDK(process.env.REACT_APP_CLIENT_URL, process.env.REACT_APP_CLIENT_ID);

    const handleSubmit = async (user, { setSubmitting }) => {
        const { username, password } = user
        if (username && password) {
            try {
                const result = await loginsdk.authenticateWithPassword(username, password);
                setLoginRslt(result)
                if (result) {
                    setSubmitting(false)
                }
            } catch (error) {
                setLoginRslt(error)
                setSubmitting(false)
            }

        }
    }

    const { classes } = useStyles()
    return (
        <MainCard>
            <Box m={6}>

                <Formik
                    initialValues={{
                        username: '',
                        password: '',
                    }}
                    validate={values => {
                        let errors = {};
                        const errorMsg = "Required ! Length must be between 2 and 24";

                        if (!values.username) {
                            errors.username = errorMsg;
                        }
                        if (!values.password) {
                            errors.password = errorMsg;
                        }
                        return errors;
                    }}
                    validationSchema={Yup.object().shape({


                    })}
                    onSubmit={(
                        { username, password }, { setSubmitting }
                    ) => { handleSubmit({ username, password }, { setSubmitting }) }}
                >
                    {({ isSubmitting }) => (
                        <Form>

                            <Field
                                name="username"
                                label="Username"
                                type="text"
                                component={TextField}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                            />


                            <Field
                                name="password"
                                label="Password"
                                type="password"
                                component={TextField}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                            />


                            <Button
                                variant="outlined"
                                color="primary"
                                type="submit"
                                className={classes.button}
                                disabled={isSubmitting}>
                                {isSubmitting && <CircularProgress className={classes.progress} color="secondary" size={24} />}
                                Login using LoginID

                            </Button>
                        </Form>

                    )}

                </Formik>

                {Object.keys(loginRslt).length !== 0 && <>
                    {loginRslt.is_authenticated ? (<Grid item xs={12} sm={12} md={12} style={{ marginTop: '30px' }} >
                        <Alert severity="success">
                            <Typography variant="h5">
                                {loginRslt.is_authenticated ? 'You are login successfully' : ''}
                            </Typography>
                        </Alert>
                        <Grid container>
                            <Grid item xs={12} sm={12} md={12}>

                                {loginRslt.jwt && <>
                                    <CopyToClipboard text={loginRslt.jwt} >
                                        <Button variant="text" startIcon={<BsClipboard />} >
                                            <span style={{ color: 'black', marginRight: '10px' }}>  JWT : </span> {loginRslt.jwt.substring(0, 4)}...{loginRslt.jwt.substring(loginRslt.jwt.length - 3, loginRslt.jwt.length)}
                                        </Button>
                                    </CopyToClipboard></>

                                }
                            </Grid>
                            <Grid item xs={12} sm={12} md={12}>

                                {loginRslt.user && loginRslt.user.id && <>
                                    <CopyToClipboard text={loginRslt.user.id} >
                                        <Button variant="text" startIcon={<BsClipboard />} >
                                            <span style={{ color: 'black', marginRight: '10px' }}>  ID : </span> {loginRslt.user.id}
                                        </Button>
                                    </CopyToClipboard></>

                                }
                            </Grid>
                            <Grid item xs={12} sm={12} md={12}>

                                {loginRslt.user && loginRslt.user.username && <>
                                    <CopyToClipboard text={loginRslt.user.username} >
                                        <Button variant="text" startIcon={<BsClipboard />} >
                                            <span style={{ color: 'black', marginRight: '10px' }}>     Username : </span>  {loginRslt.user.username}
                                        </Button>
                                    </CopyToClipboard></>

                                }
                            </Grid>
                        </Grid>


                    </Grid>) : (
                        <>
                            <Grid container spacing={2} style={{ marginTop: '30px' }}>
                                <Grid item xs={12} sm={12} md={12}>

                                    <Alert severity="error"> <Typography variant="h5">
                                        <span style={{ color: 'black' }}>  Code :  </span> {loginRslt && loginRslt.code}
                                    </Typography>
                                    </Alert>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>

                                    <Alert severity="error"> <Typography variant="h5">
                                        <span style={{ color: 'black' }}> Message :  </span> {loginRslt && loginRslt.message}
                                    </Typography>
                                    </Alert>
                                </Grid>
                            </Grid>

                        </>
                    )}
                </>}
            </Box>
        </MainCard>

    )

}
const useStyles = makeStyles({ "name": { UserLoginId } })(theme => ({
    heroContent: {
        height: 'calc( 100vh - 150px)',
    },

    button: {
        margin: theme.spacing(1),
    },

    floatingLabelFocusStyle: {
        color: theme.palette.primary.main
    },
    ImgLoginDescp: {
        width: '400px',
        margin: 'auto',
        padding: '40px',
        display: 'block',
        color: 'white'
    },
    containerBox: {
        boxShadow: 'rgb(213 212 212 / 80%) 1px 5px 24px 0px',
        borderRadius: '10px',
        backgroundPosition: 'inherit',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundSize: '100%'

    },
    BoxContainerLogin: {
        background: 'white',
        padding: '50px',
        borderRadius: '10px',
        boxShadow: 'rgb(38 127 161) 1px 5px 24px 0px',

    }
}))

export default UserLoginId;
